import { useState } from 'react';
import { api } from '../lib/api';
import { Gift, Sparkles } from 'lucide-react';
import { toast } from 'sonner';

const PRESETS = [100, 150, 200];

export default function GiftCards() {
  const [amount, setAmount] = useState(100);
  const [custom, setCustom] = useState('');
  const [f, setF] = useState({ purchaser_email:'', recipient_email:'', message:'' });
  const [submitting, setSubmitting] = useState(false);

  const final = custom ? parseFloat(custom) : amount;

  const submit = async (e) => {
    e.preventDefault();
    if (!final || final < 25) { toast.error('Amount must be at least €25'); return; }
    setSubmitting(true);
    try {
      const r = await api.post('/giftcards/checkout', { ...f, amount: final, origin_url: window.location.origin });
      window.location.href = r.data.url;
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'Failed');
      setSubmitting(false);
    }
  };

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-16">
      <div className="badge-cozy mb-3">🎁 Gift Cards</div>
      <h1 className="text-4xl sm:text-5xl font-heading font-semibold mb-3">Gift a Ghostie meetup ✨</h1>
      <p className="text-[#a3a3a3] mb-10">Cozy, strange, and exactly the gift no one else will think of.</p>

      <form onSubmit={submit} className="magical-card p-8 space-y-5">
        <div>
          <label className="label">Amount</label>
          <div className="flex flex-wrap gap-2">
            {PRESETS.map(p => (
              <button type="button" key={p} onClick={()=>{setAmount(p); setCustom('');}}
                className={`chip ${!custom && amount===p ? 'active':''}`} data-testid={`gift-amount-${p}`}>€{p}</button>
            ))}
            <input placeholder="Custom €" value={custom} onChange={e=>setCustom(e.target.value)} type="number" min={25} className="input-cozy w-32 ml-2" data-testid="gift-custom"/>
          </div>
        </div>
        <div><label className="label">Your email</label><input required type="email" value={f.purchaser_email} onChange={e=>setF(s=>({...s, purchaser_email:e.target.value}))} className="input-cozy" data-testid="gift-purchaser"/></div>
        <div><label className="label">Recipient email (optional)</label><input type="email" value={f.recipient_email} onChange={e=>setF(s=>({...s, recipient_email:e.target.value}))} className="input-cozy" data-testid="gift-recipient"/></div>
        <div><label className="label">Message (optional)</label><textarea rows={3} value={f.message} onChange={e=>setF(s=>({...s, message:e.target.value}))} className="input-cozy" data-testid="gift-message"/></div>
        <div className="flex items-center justify-between border-t border-[#3f2e1e] pt-5">
          <div className="text-3xl font-heading font-semibold text-[#f97316]">€{final?.toFixed(2) || '0.00'}</div>
          <button disabled={submitting} className="btn-primary" data-testid="gift-submit"><Gift size={16}/> {submitting?'...':'Buy gift card'}</button>
        </div>
      </form>
      <p className="text-xs text-[#a3a3a3] mt-4 text-center">Gift cards can currently be redeemed by contacting us with the code. Full checkout-time redemption coming soon.</p>
    </div>
  );
}
